import React from "react";
import { Link, Link as RouterLink } from "react-router-dom";
import {
    makeStyles,
    Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {
    useTable,
} from "react-table";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";

const useStyles = makeStyles((theme) => ({
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    text: {
        textDecoration: "none",
        color: "#306F9D",
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));

const ScoreBoardPage = (props) => {
    const { match, disabled } = props;
    const classes = useStyles();
    const [data, setData] = React.useState([]);
    const { setLoading } = useLoading();
    const columns = React.useMemo(
        () => [
            {
                Header: "Rank",
                accessor: (row) => {
                  return (row.rank === null)? '-' : row.rank;
                },
            },
            {
                Header: "Name",
                accessor: (row) => {
                  return (row.name === null)? '-' : row.name;
                },
            },
            {
                Header: "Director",
                accessor: (row) => {
                  return (row.director === null)? '-' : row.director;
                },
            },
            {
                Header: "Ticket for Sale",
                accessor: (row) => {
                  return (row.totalSeat === null)? '-' : row.totalSeat;
                },
            },
            {
                Header: "Ticket Sold",
                accessor: (row) => {
                  return (row.ticketSold === null)? '-' : row.ticketSold;
                },
            },
            {
                Header: "Total Vote",
                accessor: (row) => {
                  return (row.totalVotes === null)? '-' : row.totalVotes;
                },
            },
            {
                Header: "Total Score of Star",
                accessor: (row) => {
                  return (row.totalStarScore === null)? '-' : row.totalStarScore;
                },
            },
            {
                Header: "Final Score",
                accessor: (row) => {
                  return (row.score === null)? '-' : Number(row.score).toFixed(2);
                },
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
        },
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                ...columns,
            ]);
        }
    );

    const getScoreBoard = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getHkiffScoreBoard();
            console.log('RESULT:', result)
            setData(result.data.slice(0, 10));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    React.useEffect(() => {
        getScoreBoard();
    }, [getScoreBoard]);

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                {"Score Board"}
            </Typography>
            <form>
                <Grid
                    container
                    justify="space-between"
                    style={{ paddingBottom: "10px" }}
                >
                    <Grid container item xs={6} md={6}>
                    </Grid>
                    <Grid container item xs={6} md={6}>
                        <Box
                            width="100%"
                            component="span"
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    component={"a"}
                                    download
                                    href={`${
                                    process.env.REACT_APP_API_HOSTNAME ||
                                    "https://hkiff-api-dev.cloud.udev.hk"
                                    }/hkiff/admin/aca/score-board-image`}
                                >
                                    Export Score board
                                    </Button>
                            </Box>
                            <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    component={"a"}
                                    download
                                    href={`${
                                    process.env.REACT_APP_API_HOSTNAME ||
                                    "https://hkiff-api-dev.cloud.udev.hk"
                                    }/hkiff/admin/aca/export-vote-log`}
                                >
                                    Export Vote Log
                                    </Button>
                            </Box>
                            <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    component={"a"}
                                    download
                                    href={`${
                                    process.env.REACT_APP_API_HOSTNAME ||
                                    "https://hkiff-api-dev.cloud.udev.hk"
                                    }/hkiff/admin/aca/export-vote-record`}
                                >
                                    Export Vote Record
                                    </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <TableContainer
                        component={Paper}
                        style={{
                            boxShadow: "none",
                            border: "1px solid #cccccc",
                        }}
                    >
                        <fieldset disabled={disabled}
                            className="fieldset">
                            <Table
                                aria-label="simple table"
                                component="ul"
                                style={{ margin: "0" }}
                                {...getTableProps()}
                            >
                                <colgroup>
                                    <col
                                        style={{ width: "1%" }} />
                                    <col
                                        style={{ width: "10%" }} />
                                    <col
                                        style={{ width: "20%" }} />
                                    <col
                                        style={{ width: "20%" }} />
                                    <col
                                        style={{ width: "10%" }} />
                                    <col
                                        style={{ width: "20%" }} />
                                    <col
                                        style={{ width: "10%" }} />
                                </colgroup>
                                <TableHead component="div">
                                    {headerGroups.map((headerGroup) => (
                                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <TableCell
                                                    {...column.getHeaderProps()}
                                                    className={`${column.className ?? ""}`}
                                                    style={{
                                                        paddingTop: 6,
                                                        paddingBottom: 6,
                                                        lineHeight: "1.1em",
                                                        height: "48px",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => {
                                        prepareRow(row);
                                        console.log('row', row);
                                        return (
                                            <TableRow {...row.getRowProps()}>
                                                {row.cells.map((cell) => {
                                                    return (
                                                        <TableCell
                                                            {...cell.getCellProps()}
                                                            className={`${cell.column.className ?? ""}`}
                                                            style={{
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                lineHeight: "1.1em",
                                                                height: "48px",
                                                            }}
                                                        >
                                                            {cell.render("Cell")}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </fieldset>
                    </TableContainer>
                </Grid>
                <Grid
                    container
                    justify="flex-end"
                    style={{
                        paddingRight: "25px",
                        marginTop: "15px"
                    }}
                >
                </Grid>
            </form>
        </div>
    );
};

export default ScoreBoardPage;
